import { Span, theme } from '@ahmdigital/ui';
import Icon from '@ahmdigital/icons-web';
import React from 'react';

import { COVERAGE_INCLUSION } from '../../../../../constants';
import styles from './styles.module.sass';

const ICON_MAPPING = {
  [COVERAGE_INCLUSION.EXCLUDED]: {
    fill: theme.colors.red,
    name: 'cross-circle',
  },
  [COVERAGE_INCLUSION.INCLUDED]: {
    fill: theme.colors.green,
    name: 'tick-circle',
  },
  [COVERAGE_INCLUSION.OPTIONAL]: {
    fill: theme.colors.blue,
    name: 'plus-circle',
  },
};

const TITLE_MAPPING = {
  [COVERAGE_INCLUSION.EXCLUDED]: 'Excluded',
  [COVERAGE_INCLUSION.INCLUDED]: 'Included',
  [COVERAGE_INCLUSION.OPTIONAL]: 'Optional',
};

type CellProps = {
  inclusionType: 'excluded' | 'included' | 'optional';
};

const Cell = ({ inclusionType }: CellProps) => (
  <Span className={styles.cell}>
    <Icon {...ICON_MAPPING[inclusionType]} size="small" />
    <Span className={styles.label}> {TITLE_MAPPING[inclusionType]}</Span>
  </Span>
);

export default Cell;
